export default "__VITE_ASSET__dbeac8f3__"